/**
 * Shared TinyMCE configuration helpers.
 *
 * When TinyMCE is used inside a modal it appends its floating UI
 * (.tox-tinymce-aux) directly to <body> and sets a z-index via inline style.
 * That inline z-index sits below the modal's z-index (2147483645), so menus
 * and sub-menus appear hidden behind the modal.
 *
 * The setup callback below runs after every editor initialises and bumps the
 * shared aux element to 2147483646 — one above the modal — using
 * setProperty('…','important') so it beats any competing inline or stylesheet
 * rule that TinyMCE may have already applied.
 */

export const TINYMCE_API_KEY = "e4kmr66e3tqyrdxqk84c9ucybc5l3qzaum53urpf5q3ccg54";

export const TINYMCE_SETUP = (editor: any) => {
  editor.on("init", () => {
    const auxEl = document.querySelector(".tox-tinymce-aux") as HTMLElement | null;
    if (auxEl) {
      auxEl.style.setProperty("z-index", "2147483646", "important");
    }
  });
};

export const TINYMCE_INIT: Record<string, any> = {
  plugins:
    "emoticons link lists media searchreplace table visualblocks wordcount paste contextmenu",
  toolbar:
    "undo redo | fontsize | bold italic underline strikethrough | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
  paste_data_images: false,
  paste_enable_default_filters: true,
  paste_auto_cleanup_on_paste: true,
  paste_remove_styles: false,
  paste_remove_styles_if_webkit: false,
  contextmenu: "cut copy paste | link table",
  tinycomments_mode: "embedded",
  tinycomments_author: "Author name",
  invalid_elements: "script",
  menubar: false,
  branding: false,
  mergetags_list: [
    { value: "First.Name", title: "First Name" },
    { value: "Email", title: "Email" },
  ],
};
